<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col>
            <h1>
              <v-btn
                color="primary"
                x-small
                text
                @click="() => this.$router.go(-1)"
                :disabled="submittingForm"
              >
                <v-icon left> fa fa-angle-left </v-icon> </v-btn
              >DIÁRIO ATENDIMENTO
            </h1>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title>DIÁRIO DE DESENVOLVIMENTO</v-card-title>
          <v-card-text>
            <h4>Turma: {{ gestao?.turma ? gestao?.turma.descricao : "- - -" }}</h4>
            <h4>Aluno: {{ matricula?.aluno ? matricula?.aluno.nomecompleto : "- - -" }}</h4>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-title>Profissionais (diários)</v-card-title>
          <v-card-text>
            <div>
              Profissional: {{ gestao?.profissional ? gestao?.profissional.name : "- - -" }}
            </div>
          </v-card-text>
        </v-card>
        <v-col cols="12" class="pt-3 px-0">
          <div class="d-flex justify-space-between">
            <div>
              <v-btn
                color="success"
                :to="{
                  name: 'educacaoInclusivaDiario.create',
                  params: { matricula_id: $route.params.matricula_id },
                  params: { gestao_id: $route.params.gestaoDeAulasId },
                }"
                class="mr-2"
                >Criar atendimento
              </v-btn>
              <v-btn color="primary" class="mr-2" @click="abrirModalSemestral">
                Anexar/Baixar Planejamento Semestral
              </v-btn>
            </div>
            <v-text-field
              v-model="search"
              class="ml-2 search-input"
              append-icon="mdi-magnify"
              label="Pesquisar..."
              solo
              autofocus
              dense
              single-line
              hide-details
            />
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="aulasList"
          :items-per-page="10"
          :custom-filter="dataTableFilter"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                color="primary"
                :class="ficha.estaDeletado ? ['deleted'] : []"
                v-for="ficha of items"
                :key="ficha.id"
              >
                <td>{{ ficha.id }}</td>
                <td>{{ ficha.data_formatada }}</td>
                <td class="text-left">{{ ficha.horario ? ficha.horario.descricao : "- - -" }}</td>
                <td class="text-left">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        :color="ficha.aluno_presente === 1 ? 'green' : 'red'"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!podeAlterar"
                        @click="changePresenca(ficha)"
                      >
                        <v-icon small>
                          {{ ficha.aluno_presente === 1 ? "fa fa-thumbs-up" : "fa fa-thumbs-down" }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      ficha.aluno_presente === 1
                        ? "Aluno Presente"
                        : "Justificativa: " + (ficha.justificativa ?? "Sem justificativa")
                    }}</span>
                  </v-tooltip>
                </td>

                <td class="text-left">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        :color="ficha.confirmada === 1 ? 'green' : 'red'"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!podeAlterar"
                        @click="changeConfirmacao(ficha.id)"
                      >
                        <v-icon small>
                          {{ ficha.confirmada === 1 ? "fa fa-thumbs-up" : "fa fa-thumbs-down" }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      ficha.confirmada === 1
                        ? "Atendimento confirmado"
                        : "Nao confirmou atendimento"
                    }}</span>
                  </v-tooltip>
                </td>

                <td width="25%" class="text-center">
                  <v-tooltip color="primary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => visualizarAtendimento(ficha)"
                      >
                        <v-icon small>fa fa-eye </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar Atendimento</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!!ficha.confirmada || !podeAlterar"
                        @click="() => editarDiario(ficha)"
                      >
                        <v-icon small>fa fa-edit </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar atendimento</span>
                  </v-tooltip>
                  <v-tooltip color="error" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!!ficha.confirmada || !podeAlterar"
                        @click="() => deletarDiario(ficha)"
                      >
                        <v-icon small>fa fa-trash </v-icon>
                      </v-btn>
                    </template>
                    <span>Apagar atendimento</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <e-drawer-visualizar-atendimento
      v-model="visualizarAtendimentoDrawer"
      :atendimento="atendimento"
      :aee="true"
    >
    </e-drawer-visualizar-atendimento>

    <v-dialog v-model="faltaModal" max-width="500px">
      <v-card>
        <v-card-title>Justificativa</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="justificativa"
            label="Informe a justificativa para a ausência"
            outlined
            dense
            counter="500"
            maxlength="500"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="faltaModal = false">Cancelar</v-btn>
          <v-btn
            text
            color="primary"
            @click="confirmarAusencia"
            :disabled="!justificativa || justificativa.length > 500"
            >Confirmar falta</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <e-anexar-planejamento-semestral-modal
      :dialog="modalSemestral"
      :matricula_id="$route.params.matricula_id"
      :gestao_id="$route.params.gestaoDeAulasId"
      @dialogChange="modalSemestral = $event"
    ></e-anexar-planejamento-semestral-modal>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import { dataTableFilter } from "@/plugins/searchQuery";

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  mounted() {
    this.loadBasicData();
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    podeAlterar() {
      const rolesPermitidas = [
        "coordenador-caee",
        "gerente-administrativo",
        "diretor-caee",
        "admin",
        "super-admin",
      ];
      return rolesPermitidas.includes(this.user?.roleName);
    },
  },
  data() {
    return {
      form: {
        data: null,
        horario_aee_id: {
          descricao: "Escolha um horario",
        },
      },
      atendimento: {},
      visualizarAtendimentoDrawer: false,
      dataTableFilter,
      gestoesDeAulasList: [],
      aulasList: [],
      carregandoAulas: false,
      modal: false,
      menu: false,
      horarios: [],
      gestao: null,
      matricula: null,
      gestao_de_aulas: [],
      submittingForm: false,
      search: "",
      aulaSelecionada: {
        data: null,
      },
      data: null,
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Data", value: "data_formatada" },
          { text: "Horário", value: "horario_descricao" },
          { text: "Presença do Aluno", value: "presente" },
          { text: "Confirmada", value: "confirmada" },

          {
            text: "Ações",
            align: "center",
            value: "actions",
            sortable: false,
            width: "200px",
          },
        ],
      },
      faltaModal: false,
      justificativa: "",
      fichaAtual: null,
      modalSemestral: false,
    };
  },

  methods: {
    abrirModalSemestral() {
      this.modalSemestral = true;
    },

    async changePresenca(ficha) {
      if (ficha.aluno_presente === 1) {
        this.fichaAtual = ficha;
        this.faltaModal = true;
      } else {
        await this.atualizarPresenca(ficha.id, null);
      }
    },
    async confirmarAusencia() {
      await this.atualizarPresenca(this.fichaAtual.id, this.justificativa);
      this.justificativa = "";
      this.faltaModal = false;
    },
    async atualizarPresenca(id, justificativa) {
      await this.$services.educacaoInclusivaService.mudarPresenca(id, justificativa);
      this.loadBasicData();
    },
    async changeConfirmacao(id) {
      try {
        await this.$services.educacaoInclusivaService.mudarConfirmacao(id);
        this.loadBasicData();
      } catch (error) {
        this.$handleError(error);
      }
    },
    visualizarAtendimento(atendimento) {
      this.visualizarAtendimentoDrawer = !this.visualizarAtendimentoDrawer;
      this.atendimento = atendimento;
    },

    editarDiario(ficha) {
      this.$router.push({
        name: "educacaoInclusivaDiario.edit",
        params: { id: ficha.id, matricula_id: ficha.matricula_id },
      });
    },

    async deletarDiario(ficha) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar este atendimento?",
        confirmationCode: ficha.id,
        confirmationMessage: `Por favor, digite <strong>${ficha.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando o atendimento");
              try {
                await this.$services.educacaoInclusivaService.deletar(ficha);
                this.aulasList = this.aulasList.filter((item) => item.id !== ficha.id);
                this.$toast.success("Atendimento deletado com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },

    async createOrUpdate() {
      this.submittingForm = true;
      this.$loaderService.open("Carregando dados...");
      try {
        this.form.data = this.data;
        const { gestao_id } = this.$route.params;
        this.form.gestao_id = gestao_id;
        this.$toast.info("Relatório salvo com sucesso!");
        await this.$services.educacaoInclusivaService.lancarFichaDeDiarioAtendimento(this.form);
      } catch (error) {
        this.$handleError(error);
      }
      this.$router.push({ name: "gestoesDeAulasAuxiliares" });

      this.submittingForm = false;
    },

    async loadBasicData() {
      this.carregandoAulas = true;
      this.$loaderService.open("Carregando dados...");
      try {
        const { matricula_id } = this.$route.params;
        const { gestaoDeAulasId } = this.$route.params;
        const response =
          await this.$services.educacaoInclusivaService.carregarFichaDeDiarioAtendimento(
            matricula_id,
            gestaoDeAulasId
          );

        this.aulasList = response.ficha;
        this.form = response.ficha ? response.ficha : {};
        this.lancarRelatorio = this.$constants.fichaEducacaoEspecialDiario;
        this.gestao = response.gestao;
        this.matricula = response.matricula;
        this.horarios = response.horarios;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style></style>
